import type { ContentPageData } from '../types'

export const supplementalPages: ContentPageData[] = [
  { id: 481, slug: 'المجلات-العلمية-الدورية', title: 'المجلات العلمية الدورية', excerpt: '', blocks: [] },
  { id: 378, slug: 'مجلة-أهل-الصفة-لدراسات', title: 'مجلة أهل الصفة لدراسات', excerpt: '', blocks: [] },
  { id: 308, slug: 'ترجمة-ومنهج', title: 'ترجمة ومنهج', excerpt: '', blocks: [] },
  { id: 226, slug: 'home', title: 'Home', excerpt: '', blocks: [] },
  {
    id: 2,
    slug: 'sample-page',
    title: 'Sample Page',
    excerpt: '',
    blocks: [
      { type: 'paragraph', value: 'This is an example page. It is different from a blog post because it will stay in one place and will show up in your site navigation (in most themes).' },
      { type: 'paragraph', value: 'Most people start with an About page that introduces them to potential site visitors. It might say something like this:' },
      { type: 'paragraph', value: 'Hi there! I am a bike messenger by day, aspiring actor by night, and this is my website. I live in Los Angeles, have a great dog named Jack, and I like pina coladas. (And getting caught in the rain.)' },
      { type: 'paragraph', value: '...or something like this:' },
    ],
  },
]
